import { Modal, styled } from "@mui/material";

export const BottomSheetWithDialog = styled(Modal)<any>`
  backdrop-filter: blur(5px);
  background: none;
  -webkit-backdrop-filter: blur(2px);

  .MuiBox-root {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${({ width }: any) => (width ? width : "500px")};
    background-color: var(--secondary-theme-color);
    padding: 20px;
    top: 50%;
    border-radius: 20px;
    max-height: 80%;
  }

  @media screen and (max-width: 840px) {
    .MuiBox-root {
      bottom: 0%;
      top: auto;
      width: calc(100% - 20px);
      padding: 20px;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      transform: translate(-50%, 0%);
      max-height: 85%;
    }
  }
`;
